import { render, staticRenderFns } from "./HomeTaskRow.vue?vue&type=template&id=b203dee0&"
import script from "./HomeTaskRow.vue?vue&type=script&lang=js&"
export * from "./HomeTaskRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports